export default __webpack_public_path__ + "static/media/loading.8d7cd1dd.gif";